import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface DistrictAdminTeacher {
  id: number | null
  schoolId: number | null
  firstName: string | null
  lastName: string | null
  numFocusSessions: number | null
  lastActivityAt: string | null
  isActive: boolean | null
}

export const selectTeachers = (state: any) => state.districtTeachers
export const selectTeachersBySchool = (schoolId: number) => (state: any) => state.districtTeachers.filter((teacher: DistrictAdminTeacher) => teacher.schoolId === schoolId)
export const selectTeacher = (id: number) => (state: any) => state.districtTeachers.find((teacher: DistrictAdminTeacher) => teacher.id === id)

const initialState: DistrictAdminTeacher[] = [{
    id: null,
    schoolId: null,
    firstName: null,
    lastName: null,
    numFocusSessions: null,
    lastActivityAt: null,
    isActive: null,
}]

const teachersSlice = createSlice({
    name: 'districtTeachers',
    initialState,
    reducers: {
        loadTeachers: (state, {
            payload: teachers,
        }: PayloadAction<any[]>) => teachers.map((teacher: any) => ({
            id: teacher.id,
            schoolId: teacher.schoolId,
            firstName: teacher.firstName,
            lastName: teacher.lastName,
            numFocusSessions: teacher.numFocusSessions,
            lastActivityAt: teacher.lastActivityAt,
            isActive: teacher.isActive,
        })),
    },
})

export const { loadTeachers } = teachersSlice.actions

export default teachersSlice.reducer
